import { Button, Modal, Trans } from '@/components'

interface DeleteConfirmModalProps {
  open: boolean
  loading?: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Shared modal for confirming file/folder deletion
 */
export function DeleteConfirmModal({ open, loading, onClose, onConfirm }: DeleteConfirmModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="data.deleteConfirmModal.title">Confirmation</Trans>
      </Modal.Header>
      <Modal.Body>
        <Trans i18nKey="data.deleteConfirmModal.content">
          Are you sure you want to delete the file(s)?
        </Trans>
      </Modal.Body>
      <Modal.Footer>
        <Button type="outline" onClick={onClose}>
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button type="danger" disabled={loading} onClick={onConfirm}>
          <Trans i18nKey="common.confirmModalOk">Confirm</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
